import { formatExportDateTime, isIsoDateTimeString } from "@cayo/shared/utils/date";

export function formatExportValue(value: unknown): string {
  if (value === null || value === undefined) {
    return "";
  }

  if (typeof value === "number") {
    return `${value}`;
  }

  if (typeof value === "boolean") {
    return value ? "TRUE" : "FALSE";
  }

  if (typeof value === "string") {
    if (isIsoDateTimeString(value)) {
      return formatExportDateTime(value);
    }

    return value;
  }

  if (value instanceof Date) {
    return formatExportDateTime(value);
  }

  if (typeof value === "object") {
    return JSON.stringify(value) ?? "";
  }

  return JSON.stringify(value)?.replace(/^"/, "").replace(/"$/, "") ?? "";
}
